import { FINRA_EXCHANGE_ID } from 'constants/darkpool';
import { FeedType } from './props';

/**
 * Feed-type count over realtime darkpool rows (Phase 1b).
 *
 * The DO's darkpool feed carries the complete current-day
 * `equity_print_feed_baseline` — the same row set as the
 * `equity_print_flow_full` view — so counts are a straight exchangeId split.
 * Deliberately NO dependence on `isFilteredFlow`: that stamp is wire-only
 * (producer pushes carry it, DO backfill snapshots don't), so any logic keyed
 * on it silently drops backfilled rows. See the P1 in the 2026-07 review.
 */
export function realtimeFeedTypeCount(
  rows: ReadonlyArray<{ exchangeId?: number | null }>,
  feedType: FeedType,
): number {
  if (feedType === FeedType.Dark) {
    return rows.filter((t) => t.exchangeId === FINRA_EXCHANGE_ID).length;
  }
  if (feedType === FeedType.Lit) {
    return rows.filter((t) => t.exchangeId !== FINRA_EXCHANGE_ID).length;
  }
  return rows.length;
}
